module.exports = __webpack_public_path__ + "static/NOOBZOO_SHORT_LOGO-99df917c5230c6eebe712823f21d5393.png";